import { render, staticRenderFns } from "./GeolocationQuestion.vue?vue&type=template&id=6ce24b80&scoped=true&"
import script from "./GeolocationQuestion.vue?vue&type=script&lang=js&"
export * from "./GeolocationQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce24b80",
  null
  
)

export default component.exports